import { useAuthStore } from "@/store/authStore";
import { useUserStore } from "@/store/userStore";
import { useFreelancerStore } from "@/store/freelancerStore";
import { useEnterpriseStore } from "@/store/enterpriseStore";
import axios from "axios";
import { useToast } from "@/hooks/use-toast";
import { io } from "socket.io-client";

export const Axios = axios.create({
  baseURL: `${import.meta.env.VITE_APP_BASE_URL}`,
});

export const Chat_Axios = axios.create({
  baseURL: `${import.meta.env.VITE_CHAT_APP_BASE_URL}`,
});

export const authHeaders = (accessToken) => {
  return {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };
};

Axios.interceptors.request.use((config) => {
  if (config.url?.includes("chat/conversation") || config.url?.includes("api/notifications")) {
    config.baseURL = `${import.meta.env.VITE_CHAT_APP_BASE_URL}`;
  }
  return config;
});

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const userStore = useUserStore.getState();
      const authStore = useAuthStore.getState();
      const freeLancerStore = useFreelancerStore.getState();
      const enterPriseStore = useEnterpriseStore.getState();
      userStore.autoLogout();
      authStore.logout();
      freeLancerStore.clearFreelancerProfile();
      enterPriseStore.clearEnterpriseProfile();
      localStorage.clear();
      const {toast} = useToast();
      toast({
        title: "Session Expired",
        description: "Your session has expired. Please log in again.",
        variant: "destructive",
      });
    }
    return Promise.reject(error);
  }
);

export const socket = io(import.meta.env.VITE_CHAT_APP_BASE_URL, {
  transports: ["websocket"],
});